import classNames from 'classnames/bind';
import React from 'react';

import { Button } from '@components/Button/Button';
import type { IErrorMessageType } from '@components/Form/ErrorMessage/ErrorMessage';
import { ErrorMessage } from '@components/Form/ErrorMessage/ErrorMessage';
import { TooltipBubble } from '@components/Tooltip/TooltipBubble/TooltipBubble';

import styles from './SubmitButton.module.scss';

const cx = classNames.bind(styles);
export interface IProps {
  id: string;
  isLoading: boolean;
  error?: boolean;
  failedAttempts?: number;
  errorPosition?: 'top' | 'right';
  type?: IErrorMessageType;
  isFullWidth?: boolean;
  children: string;
}

export const SubmitButton: React.FC<IProps> = ({
  id,
  isLoading,
  error,
  failedAttempts = 0,
  errorPosition,
  type,
  isFullWidth,
  children,
}) => {
  const [initialButtonDisabled, setInitialButtonDisabled] = React.useState(true);

  React.useEffect(() => {
    setInitialButtonDisabled(false);
  }, []);

  return (
    <TooltipBubble
      className={styles.tooltip}
      isVisible={!isLoading && error === true}
      options={{ placement: errorPosition }}
      size="md"
      text={<ErrorMessage failedAttempts={failedAttempts} type={type} />}
      isInteractive
    >
      {({ setTriggerRef, tooltip }) => (
        <>
          {tooltip}
          <div ref={setTriggerRef} className={cx('buttonWrapper', { isFullWidth })}>
            <Button
              className={styles.button}
              disabled={initialButtonDisabled}
              id={id}
              isProcessing={isLoading}
              size="xl"
              type="submit"
            >
              {children}
            </Button>
          </div>
        </>
      )}
    </TooltipBubble>
  );
};
